import axios from "axios";
import URLS from "./URLS";
import { LOGOUT_ADMIN } from "./ApiCalls";
import { disconnectSocket } from "../Socket/initializeSocket";
import { useSelector } from "react-redux";
import store from "../store/store";

const API_URL = URLS.API_URL;
class Axios {
  defaultOptions = () => {
    if (typeof window === "undefined") {
      return {
        baseURL: `${API_URL}`,
        headers: {
          token: "",
          Authorization: "",
          adminid: "",
          "Accept-Language": "en",
        },
      };
    }

    const lang = localStorage.getItem("lang") || navigator.language || "en";
  
  const state = store.getState();
  const hotelId = state?.hotel?.hotelId;

    return {
      baseURL: `${API_URL}`,
      headers: {
                  hotelId:hotelId,

        token: localStorage.getItem("token") || "",
        Authorization: "Bearer " + (localStorage.getItem("token") || ""),
        adminid: localStorage.getItem("_id") || "",
        "Accept-Language": lang,
      },
    };
  };

  LogoutUser = async (error) => {
    const status = error?.response?.status;
    console.log("status-0", status);
    console.log("error-0", error);

    if (status === 401) {
      try {
        const firebaseToken = localStorage.getItem("firebaseToken");

        if (firebaseToken) {
          await LOGOUT_ADMIN({ firebaseToken });
        }
      } catch (err) {
        console.error("Logout API failed:", err);
      } finally {
        disconnectSocket();
        // remove only auth-related data
        localStorage.clear();
        window.location.replace("/");
      }
    }
  };

  get = (url, options = {}) => {
    return axios
      .get(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  // post = (url, data, options = {}) => {
  //   console.log("POST API>>>>>>>");
  //   return axios
  //     .post(url, data, { ...this.defaultOptions(), ...options })
  //     .then((res) => {
  //       if (res.data.message && res.data.message.includes("Not Authorized")) {
  //         let err = {
  //           response: {
  //             status: 401,
  //           },
  //         };
  //         this.LogoutUser(err);
  //       } else {
  //         return res;
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.response && err.response.status === 401) {
  //         this.LogoutUser(err);
  //         return err;
  //       } else {
  //         return err;
  //       }
  //     });
  // };

  post = (url, data, options = {}) => {
    return axios
      .post(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          const err = {
            response: {
              status: 401,
              data: { message: "Not Authorized" },
            },
          };

          if (!url.includes("logout")) {
            this.LogoutUser(err);
          }
          throw err;
        }
        return res;
      })
      .catch((err) => {
        // console.log("Full Axios Error:", err);

        const backendMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error_description ||
          err?.message;

        console.log("url",);
        // console.log("Backend message:", backendMessage, "12345");
        if (err.response && err.response.status === 401 && !url.includes("logout")) {
          this.LogoutUser(err);
        }
        console.log(err, "error message");
        throw err;
      });
  };

  put = (url, data, options = {}) => {
    return axios
      .put(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  delete = (url, options = {}) => {
    return axios
      .delete(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message && res.data.message.includes("Not Authorized")) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        console.log(err, "eror")
        if (err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };
}

export default new Axios();
